import { render, staticRenderFns } from "./OrderReturnStatusBadge.vue?vue&type=template&id=4ad1515a"
import script from "./OrderReturnStatusBadge.vue?vue&type=script&lang=js"
export * from "./OrderReturnStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports